<template>
  <div class="main">
    <div class="cg_div">
      <div class="change_pwd_div">
        <div class="title">修改密码</div>
        <div class="change_inner">
          <div class="pwd_box">
            <div>
              <div>1、新密码：</div>
              <Input v-model="pwd_value" placeholder="请输入新密码" />
              <Input
                v-model="pwd_value2"
                placeholder="请输入一次新密码，确保您已经记住"
              />
            </div>
          </div>

          <div class="pwd_box">
            <div>
              <div>2、短信验证码：</div>
              <div class="send_sms_div">
                <Input
                  disabled
                  v-model="phone"
                  enter-button="获取验证码"
                  placeholder="请输入手机号"
                />
                <Button type="primary" @click="click_send_sms"> 获取验证码 </Button>
              </div>
            </div>
            <div>
              <Input v-model="sms_code_value" placeholder="请输入短信验证码" />
            </div>
          </div>

          <div class="pwd_box">
            <div>
              <div>3、图形验证码：</div>
              <div class="code_img" title="点击刷新" @click="click_refresh_code">
                <img :src="code_img" alt="" />
                <span class="code_img_txt">看不清，换一张</span>
              </div>
            </div>
            <div>
              <Input v-model="img_code_value" placeholder="请输入图形验证码" />
            </div>
          </div>
          <div class="button_affirm">
            <Button type="primary" @click="click_affirm"> 4、确认修改密码 </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page, get_browser_id } from "@/utils/http.js";
const sha1 = require("crypto-js/sha1");

export default {
  data() {
    return {
      change_pwd_id: "",
      phone: "",
      code_img: "",
      sms_id: "",

      pwd_value: "",
      pwd_value2: "",
      sms_code_value: "",
      img_code_value: "",
    };
  },
  mounted() {
    document.title = "修改密码";
    this.request_change_pwd();
  },

  methods: {
    click_send_sms() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/change_pwd_sms",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.sms_id = res.data.sms_id;
            that.$Message.success(res.msg);
          } else {
            that.$Message.info(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    request_change_pwd() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/change_pwd",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.code_img = res.data.code_img;
            that.phone = res.data.phone;
            that.change_pwd_id = res.data.change_pwd_id;
          } else {
            that.$Message.info("页面异常，请刷新页面重试~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_affirm() {
      if (this.pwd_value.length < 8) {
        this.$Message.error("新密码长度至少8位");
        return;
      }

      if (this.pwd_value != this.pwd_value2) {
        this.$Message.error("两次密码输入不一致");
        return;
      }

      var result = this.checkPassword(this.pwd_value);
      if (!result) {
        this.$Message.error("新密码需包含字母+数字");
        return;
      }

      if (this.sms_id.length == 0) {
        this.$Message.error("请发送短信验证码");
        return;
      }

      if (this.sms_code_value.length == 0) {
        this.$Message.error("请输入短信验证码");
        return;
      }

      if (this.img_code_value.length == 0) {
        this.$Message.error("请输入图形验证码");
        return;
      }

      const encryptedData = sha1(this.pwd_value);
      var pwd_str = encryptedData.toString();

      var that = this;
      var obj = {
        change_pwd_id: this.change_pwd_id,
        sms_id: this.sms_id,
        pwd: pwd_str,
        sms_code: this.sms_code_value,
        img_code: this.img_code_value,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/change_pwd_confirm",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.success(res.msg);

            setTimeout(function () {
              that.$router.push({ path: "/" });
            }, 3000);
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_refresh_code() {
      this.request_change_pwd();
    },

    checkPassword(password) {
      // 检查密码是否同时包含字母和数字
      let letterRegex = /[a-zA-Z]/; // 匹配字母
      let numberRegex = /\d+/; // 匹配数字

      if (letterRegex.test(password) && numberRegex.test(password)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.send_sms_div {
  display: flex;
  align-items: center;
}

.code_img_txt {
  margin-left: 10px;
  color: #ccc;
  font-size: 12px;
}

.code_img {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.button_affirm {
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.pwd_box {
  margin-bottom: 20px;
}

.change_inner {
  padding: 20px 40px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 20px;
}

.cg_div {
  display: flex;
  justify-content: center;
}

.change_pwd_div {
  border-radius: 10px;
  margin-top: 50px;
  width: 500px;
  background-color: #fff;
}

.main {
  background-color: #ececec;
  min-height: 100vh;
  overflow: auto;
}
</style>
